import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ApiResponse } from '@shared-models';
import { API_CONFIG, ApiConfig } from '../../api-config';

export interface CountryDocumentSelectOption {
  id: string;
  code: string;
  text: string;
}

/**
 * Select de documentos obligatorios del país.
 * GET /api/selects/country-documents?countryId=
 */
@Injectable({ providedIn: 'root' })
export class CountryDocumentsSelectService {
  private readonly http = inject(HttpClient);
  private readonly apiConfig = inject<ApiConfig>(API_CONFIG);

  getByCountry(countryId: string): Observable<CountryDocumentSelectOption[]> {
    const params = new HttpParams().set('countryId', countryId);
    return this.http
      .get<ApiResponse<CountryDocumentSelectOption[]>>(
        `${this.apiConfig.apiUrl}/selects/country-documents`,
        { params },
      )
      .pipe(map((res) => res.data ?? []));
  }
}
